<template>
  <slot v-bind="{ isToggling, isFavorite, toggleFavorite, isLoading }" />
</template>

<script>
import {
  defineComponent,
  toRefs,
  inject,
  computed,
} from "vue";
import { useQuery, useMutation } from "@vue/apollo-composable";
import { useStore } from "vuex";
import isFavoriteQuery from "@/graphql/scalar/queries/isFavorite.query.gql";
import toggleFavoriteMutation from "@/graphql/scalar/mutation/toggleFavorite.mutation.gql";
import favoriteWalletsQuery from "@/graphql/wallet/queries/favoriteWallets.query.gql";
import userFavoriteCollectionsQuery from "@/graphql/collection-with-stats/queries/userFavoriteCollections.query.gql";

const MODELS = {
  WALLET: "Wallet",
  COLLECTION: "Collection"
};

export default defineComponent({
  name: "ToggleFavorite",

  props: ["model", "id"],

  setup(props) {
    const { model, id } = toRefs(props);
    const requireLogin = inject("requireLogin");
    const store = useStore();

    const isLoggedIn = computed(() => {
      return store.getters["auth/isLoggedIn"];
    });

    const {
      result: isFavoriteResult,
      loading: isLoading,
    } = useQuery(isFavoriteQuery, () => ({ model: model.value, id: id.value }), () => ({ enabled: isLoggedIn.value }));

    const isFavorite = computed(() => {
      return isFavoriteResult.value?.isFavorite;
    });

    const {
      mutate: mutateFavorites,
      loading: isToggling,
    } = useMutation(
      toggleFavoriteMutation,

      () => ({
        variables: {
          model: model.value,
          id: id.value,
        },

        update(cache, { data: { isFavorite }}) {
          const variables = { id: id.value, model: model.value };
          let data = cache.readQuery({ query: isFavoriteQuery, variables });

          data = {
            ...data,
            isFavorite, 
          }

          cache.writeQuery({ query: isFavoriteQuery, data, variables });
        },

        refetchQueries() {
          if (MODELS.WALLET === model.value) {
            return [{ query: favoriteWalletsQuery }];
          }

          if (MODELS.COLLECTION === model.value) {
            return [{ query: userFavoriteCollectionsQuery }];
          }
        }
      })
    );

    return {
      isToggling,
      requireLogin,
      isFavorite,
      isLoading,
      isLoggedIn,
      mutateFavorites,
    };
  },
  methods: {
    async toggleFavorite() {
      if (!this.isLoggedIn) {
        await this.requireLogin();
      }

      return this.mutateFavorites();
    },
  },
});
</script>
